import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import PageFooter from '../../components/feature/PageFooter';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import About from './components/About';
import VideoSection from './components/VideoSection';
import Products from './components/Products';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import SignupSection from './components/SignupSection';
import DiscountSection from './components/DiscountSection';
import { injectJsonLd, setDocumentTitle, setMetaDescription, setCanonical } from '../../utils/seo';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://jayeondameun.kr';

    setDocumentTitle('자연담은 | 프리미엄 스피루리나 약손콩 유기농 건강식품 전문몰');
    setMetaDescription(
      '자연담은은 100% 유기농 인증 프리미엄 스피루리나 파우더, 스피루리나 정제, 약손콩 분말, 약손콩 환을 판매하는 건강식품 전문몰입니다. HACCP 인증 시설에서 당일 포장 신선 배송합니다.',
    );
    setCanonical(`${siteUrl}/`);

    const cleanup = injectJsonLd('jsonld-home', {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: '자연담은',
          url: `${siteUrl}/`,
          description: '100% 유기농 인증 프리미엄 스피루리나와 약손콩 건강식품 전문몰',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '02-3487-2025',
            email: 'homedr365@gmail.com',
            contactType: 'customer service',
            availableLanguage: 'Korean',
          },
          sameAs: [`${siteUrl}/`],
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: `${siteUrl}/`,
          name: '자연담은',
          inLanguage: 'ko-KR',
          publisher: { '@id': `${siteUrl}/#organization` },
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: `${siteUrl}/`,
          name: '자연담은 | 프리미엄 스피루리나 약손콩 유기농 건강식품 전문몰',
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/#organization` },
          description:
            '100% 유기농 인증 프리미엄 스피루리나 파우더, 스피루리나 정제, 약손콩 분말, 약손콩 환을 판매하는 건강식품 전문몰입니다. HACCP 인증 시설에서 당일 포장 신선 배송합니다.',
          inLanguage: 'ko-KR',
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '홈', item: `${siteUrl}/` },
            ],
          },
        },
        {
          '@type': 'ItemList',
          name: '자연담은 베스트 제품',
          description: '유기농 스피루리나, 약손콩 건강식품 인기 제품 모음',
          url: `${siteUrl}/products`,
          numberOfItems: 4,
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              item: {
                '@type': 'Product',
                name: '프리미엄 스피루리나 파우더',
                description: '최고급 유기농 스피루리나를 미세 분말로 가공한 프리미엄 제품',
                url: `${siteUrl}/products`,
                offers: { '@type': 'Offer', price: 38000, priceCurrency: 'KRW', availability: 'https://schema.org/InStock' },
              },
            },
            {
              '@type': 'ListItem',
              position: 2,
              item: {
                '@type': 'Product',
                name: '유기농 스피루리나 정제',
                description: '간편하게 섭취할 수 있는 정제 형태의 스피루리나',
                url: `${siteUrl}/products`,
                offers: { '@type': 'Offer', price: 32000, priceCurrency: 'KRW', availability: 'https://schema.org/InStock' },
              },
            },
            {
              '@type': 'ListItem',
              position: 3,
              item: {
                '@type': 'Product',
                name: '약손콩 분말',
                description: '국내산 약손콩을 곱게 갈아 만든 고소한 분말',
                url: `${siteUrl}/products`,
                offers: { '@type': 'Offer', price: 28000, priceCurrency: 'KRW', availability: 'https://schema.org/InStock' },
              },
            },
            {
              '@type': 'ListItem',
              position: 4,
              item: {
                '@type': 'Product',
                name: '약손콩 환',
                description: '전통 방식으로 만든 약손콩 환',
                url: `${siteUrl}/products`,
                offers: { '@type': 'Offer', price: 25000, priceCurrency: 'KRW', availability: 'https://schema.org/InStock' },
              },
            },
          ],
        },
      ],
    });

    return cleanup;
  }, []);

  return (
    <div className="min-h-screen" style={{ fontFamily: 'Noto Sans KR, sans-serif' }}>
      <Navbar />
      <main>
        <Hero />
        <Benefits />
        <About />
        <VideoSection />
        <Products />
        <Testimonials />
        <SignupSection />
        <DiscountSection />
        <CTA />
      </main>
      <PageFooter />
    </div>
  );
}
